import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface CountryWithCities {
  country: string;
  cityCount: number;
  cities: Array<{
    name: string;
    slug: string;
    state_province: string | null;
  }>;
}

export const useCountriesWithCities = () => {
  return useQuery({
    queryKey: ['countries-with-cities'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('cities')
        .select('country, name, slug, state_province')
        .eq('is_active', true)
        .order('country', { ascending: true })
        .order('name', { ascending: true });

      if (error) throw error;

      // Group cities by country
      const countriesMap = new Map<string, CountryWithCities>();

      data.forEach((city) => {
        if (!countriesMap.has(city.country)) {
          countriesMap.set(city.country, {
            country: city.country,
            cityCount: 0,
            cities: []
          });
        }

        const countryData = countriesMap.get(city.country)!;
        countryData.cityCount++;
        countryData.cities.push({
          name: city.name,
          slug: city.slug,
          state_province: city.state_province
        });
      });

      return Array.from(countriesMap.values()).sort((a, b) => 
        a.country.localeCompare(b.country)
      );
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
};
